export default "__VITE_ASSET__oH4MdZUl__"